import { useState } from "react";
import { useAuthContext } from '@/context/AuthContext';
import { useParams } from "react-router-dom";
import {userManager} from '@/components/authentication/keycloak.js';

export const useGetConsultantCompanyBenefitInvoice = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [data, setData] = useState(null);
  const {id} = useParams();

  const getConsultantCompanyBenefitInvoice = async (companyBenefitInvoiceFileUuid) => {
    setLoading(true);
    setError(null);
    const user = await userManager.getUser();

    try {
      const response = await fetch(window.ENV.BACKEND_URL+`/api/secured/admin/companyBenefit/companyBenefitInvoiceFile/${id}/${companyBenefitInvoiceFileUuid}`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${user.access_token}`,
        },
      });

      if (!response.ok) {
        throw new Error("Failed to retrieve consultant company benefit invoice");
      }

      const blob = await response.blob();
      const url = URL.createObjectURL(blob);
      setData({ url, type: blob.type });
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return { getCompanyBenefitInvoice : getConsultantCompanyBenefitInvoice, loading, error, data };
};
